const highlights = [
  { icon: "ri-leaf-line", title: "Energy Efficient", desc: "Systems designed to minimise power consumption and reduce long-term operational costs." },
  { icon: "ri-tools-line", title: "Custom Ductwork", desc: "In-house fabricated galvanised and stainless steel ductwork precision-cut to any specification." },
  { icon: "ri-award-line", title: "Certified Engineers", desc: "Our HVAC technicians are trained and certified to international standards." },
  { icon: "ri-home-gear-line", title: "Full Turnkey", desc: "We handle everything — design, supply, fabrication, installation, commissioning and maintenance." },
];

export default function HvacOverview() {
  return (
    <section id="overview" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="w-full h-[520px] rounded-lg overflow-hidden">
              <img
                src="/images/hvac/ductwork.webp"
                alt="HVAC Installation Engineers"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white rounded-lg p-5 hidden lg:block">
              <p className="text-3xl font-extrabold leading-none">300+</p>
              <p className="text-teal-200 text-xs uppercase tracking-wider mt-1">Projects Completed</p>
            </div>
          </div>

          {/* Content side */}
          <div>
            <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">Who We Are</span>
            <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight mb-6 leading-tight">
              Complete HVAC<br />
              <span className="text-teal-600">Engineering</span> Solutions
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              ISMAN Engineering has been at the forefront of HVAC system design and installation in Kenya since 2008. Our in-house team of mechanical engineers and certified HVAC technicians delivers custom climate control solutions for commercial, industrial, and institutional clients.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              From split unit installations in offices to full central air handling unit systems in hospitals and hotels, we engineer each project from the ground up — ensuring optimal airflow, energy efficiency, and long-term reliability.
            </p>

            {/* Highlights grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {highlights.map((h) => (
                <div key={h.title} className="bg-gray-50 rounded-lg p-4 border border-gray-100 hover:border-teal-200 transition-colors group">
                  <div className="w-9 h-9 flex items-center justify-center bg-teal-50 rounded-md mb-3 group-hover:bg-teal-600 transition-colors">
                    <i className={`${h.icon} text-base text-teal-600 group-hover:text-white transition-colors`}></i>
                  </div>
                  <h4 className="text-gray-900 font-bold text-xs uppercase tracking-wide mb-1">{h.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{h.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
